import {
  Div,
  Icon,
  ProviderConnectionConnectedIcon,
  ProviderConnectionPendingIcon,
  TooltipWrapper,
  X,
  lightTheme,
} from '@vgrubs/components';

const formatGrantedAt = (iso?: string) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

type Props = {
  granted: boolean;
  grantedAt?: string;
  /** When granted, renders a gray "x" beside the icon to undo the grant. */
  onRemove?: () => void;
  /** Show the pending icon while not granted. Off on the partner card, where the CTA is the state. */
  showPending?: boolean;
};

/**
 * The access state as the same 24px status icon the provider rows use
 * (ProviderConnectionStatusComponent), with the detail in a tooltip.
 */
export const IntegrationStatusChip = ({
  granted,
  grantedAt,
  onRemove,
  showPending = false,
}: Props) => {
  if (!granted) {
    if (!showPending) return null;
    return (
      <TooltipWrapper tooltip="Pending">
        <Icon>
          <ProviderConnectionPendingIcon />
        </Icon>
      </TooltipWrapper>
    );
  }

  const date = formatGrantedAt(grantedAt);

  return (
    <Div $flex $alignCenter $gap="6px">
      <TooltipWrapper tooltip={`Access granted${date ? ` · ${date}` : ''}`}>
        <Icon>
          <ProviderConnectionConnectedIcon />
        </Icon>
      </TooltipWrapper>
      {onRemove && (
        <Icon
          $size="14"
          $pointer
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <X fill={lightTheme.lightGray} />
        </Icon>
      )}
    </Div>
  );
};
